import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f90308e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = {
  key: 0,
  class: "pc-header-padding"
}
const _hoisted_3 = { class: "scrape-settings-header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "page-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "switchbox_icon" }, null, -1))
const _hoisted_8 = { class: "section-header" }
const _hoisted_9 = { class: "section-list" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_11 = { class: "scrape-info" }
const _hoisted_12 = { class: "scrape-dirname" }
const _hoisted_13 = { class: "scrape-path" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-tips" }, " 添加视频所在文件夹到个人片库吧～ ", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "container is-loading"
}
const _hoisted_18 = {
  key: 0,
  class: "page-footer"
}

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import AndroidPullToRefresh from '@remote/components/interaction/AnPullToRefresh.vue'
import SwitchBox from '@remote/components/switchbox/SwitchBox.vue'
import GradientButton from '@remote/components/GradientButton.vue'
import SVGIcon from '@remote/components/SVGIcon.vue'
import Exception from './Exception.vue'
import Modal from '@remote/components/modal'
import { store } from '@remote/store'
import { useEnvStore } from '@remote/store/env'
import { useHeziScrapeSettingsStore } from '@remote/store/scrape'
import { checkState } from '@remote/store/utils'
// import { usePathSelector } from '@remote/store/hezi-file/path-selector'
import { toast } from '@remote/utils'
import { buildSourceList, extractUUID } from './helper'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import { logs } from './helper'
import type { TEmptyType, IPathPickerResult } from './type'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const title = ref('片库视频来源目录')
const subtitle = ref('片库会智能显示您添加的目录下的视频')
document.title = title.value

const router = useRouter()
const envStore = useEnvStore()
const isFullScreen = computed(() => store.getters.isFullScreen)
// const pathSelectorStore = usePathSelector()
const settings = useHeziScrapeSettingsStore()
const isLoading = computed(() => settings.isIniting)
const error = computed(() => settings.error)
const hasError = computed(() => !!error.value.type)
const isScrapeAll = computed(() => settings.data.isScrapeAll)
const sections = computed(() => buildSourceList(settings.data.scrapePaths))
const isEmpty = computed(() => {
  if (settings.isLoading) return false
  if (settings.data.isScrapeAll) return false
  return !settings.data.scrapePaths.length
})
const handleBack = () => {
  router.go(-1)
}

function onToggleScrapeAllSwitch () {
  settings.toggleScrapeAll()
}

function triggerAddScrapePath () {
  // pathSelectorStore.toggleVisibleSelectFolder(true)
  if (checkState(true)) return
  Modal.showHeziMulPathSelector({
    mask: true,
    closeOnMaskClick: false,
    onConfirm: onAddScrapePath,
  })
}

function onAddScrapePath (paths: Array<Pick<IPathPickerResult, 'id' | 'path' | 'diskName'>>) {
  const list = paths.map(path => {
    const isInternal = path.diskName === '内置磁盘'
    const uuid = extractUUID(path.path)
    const diskPath = isInternal ? `/xos_storage/v1/${uuid}` : ''
    const item: Pick<IPathPickerResult, 'path' | 'diskName'> = {
      diskName: path.diskName,
      path: !isInternal ? path.path : path.path.replace(diskPath, '').replace(/^\/+/, ''),
    }
    return item
  })
  return settings.addPath(list.map(p => {
    return {
      path: p.path,
      disk_name: p.diskName,
    }
  }))
}

async function onRefresh (callback) {
  settings.refresh().then(() => {
    toast('刷新成功')
    callback('done')
  }).catch(() => {
    toast('刷新失败')
    callback('fail')
  })
}

// watch(
//   () => pathSelectorStore.selectedPath.value,
//   (newVal: IPathPickerResult) => {
//     logs('路径选择发生变化:', newVal)
//     if (newVal) onAddScrapePath(newVal)
//   },
// )

function onDelete (pid: string) {
  const onConfirm = async () => {
    return settings.deletePath(pid)
  }

  Modal.show({
    title: '确定要移除目录吗？',
    actions: [{
      id: 'delete',
      text: '确定',
      loadingText: '确定中...',
      callback: onConfirm,
    }],
  })
}

function onRetry () {
  logs('重试刷新')
  settings.refresh()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page sub-page", { 'sl-full': _unref(isFullScreen), 'android-padding': _unref(isAndroid), 'ios-padding': _unref(isIOS) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(envStore).isInPC)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: "javascript:;",
        class: "qh-icon-back",
        title: "返回",
        onClick: handleBack
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(title.value), 1),
        _createElementVNode("h4", _hoisted_5, _toDisplayString(subtitle.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_unref(isLoading))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['container', _unref(hasError) ? 'with-error' : 'with-scrape', { 'no-data': _unref(isEmpty) }])
          }, [
            (_unref(hasError))
              ? (_openBlock(), _createBlock(Exception, {
                  key: 0,
                  type: (_unref(error).type as TEmptyType),
                  "empty-text": _unref(error).hints,
                  onRetry: onRetry
                }, null, 8, ["type", "empty-text"]))
              : (_openBlock(), _createBlock(AndroidPullToRefresh, {
                  key: 1,
                  "no-scrollbar": true,
                  indicator: { color: '#FCD68F', backgroundColor: '#fff' },
                  onRefresh: onRefresh
                }, {
                  default: _withCtx(() => [
                    _createVNode(SwitchBox, {
                      title: "全部目录",
                      checked: _unref(isScrapeAll),
                      onChange: onToggleScrapeAllSwitch
                    }, {
                      prefix: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    (!_unref(isEmpty))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["scrape-path-list", { 'disabled': _unref(isScrapeAll) }])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
                            return (_openBlock(), _createElementBlock("section", {
                              key: section.id,
                              class: "scrape-section"
                            }, [
                              _createElementVNode("h5", _hoisted_8, _toDisplayString(section.title), 1),
                              _createElementVNode("ul", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.data, (path) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: path.id,
                                    class: _normalizeClass(["section-item", { 'is-special': path.path.replace(/^\.\//, '') === '我的下载' }])
                                  }, [
                                    _hoisted_10,
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("h4", _hoisted_12, _toDisplayString(path.name), 1),
                                      _createElementVNode("h5", _hoisted_13, _toDisplayString(path.dir), 1)
                                    ]),
                                    _createElementVNode("span", {
                                      class: "del-icon",
                                      onClick: ($event: any) => (onDelete(path.id))
                                    }, [
                                      _createVNode(SVGIcon, { name: "del" })
                                    ], 8, _hoisted_14)
                                  ], 2))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ], 2))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["empty-list", { 'disabled': _unref(isScrapeAll) }])
                        }, _hoisted_16, 2))
                  ]),
                  _: 1
                }))
          ], 2))
        : (_openBlock(), _createElementBlock("div", _hoisted_17))
    ]),
    (!(_unref(hasError) || _unref(isScrapeAll)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(GradientButton, {
            class: "add-scrape-btn",
            text: "添加目录",
            onClick: triggerAddScrapePath
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})